import { useAuthStore } from "@/stores/auth";
import { useBillingStore } from "@/stores/billing";

export default defineNuxtRouteMiddleware(async () => {
  const authStore: any = useAuthStore();
  const billingStore = useBillingStore();
  const localePath = useLocalePath();

  if (!authStore.loggedIn || !authStore.user || authStore.user.role !== "customer-admin") {
    return;
  }

  await billingStore.refreshFeatureFlags();

  // Users with access are redirected to the SmartDodos dashboard by the page's own
  // onMounted (a single SSO exchange). Doing it here too meant a failed exchange fell
  // through and the page retried — two JWTs, two upstream calls, duplicate error logs.
  if (billingStore.hasEnergyMonitoringAccess) {
    return;
  }

  if (billingStore.energyMonitoringConnectionSize) {
    return navigateTo(`${localePath("/dashboard/billing")}#energy-monitoring-addon`);
  }
});
